/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'ACESProviderSearch' store object.
 * @namespace ACESProviderSearchSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UAACESProviderSearch';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESProviderSearchSelectors
   */
  static fetchAcesChapBurialProviderSearch = state =>
    state[selectors.moduleIdentifier].fetchAcesChapBurialProviderSearch.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESProviderSearchSelectors
   */
  static isFetchingFetchAcesChapBurialProviderSearch = state =>
    state[selectors.moduleIdentifier].isFetchingFetchAcesChapBurialProviderSearch.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESProviderSearchSelectors
   */
  static fetchAcesChapBurialProviderSearchError = state =>
    state[selectors.moduleIdentifier].fetchAcesChapBurialProviderSearchError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESProviderSearchSelectors
   */
  static fetchAcesChapInsuranceProviderSearch = state =>
    state[selectors.moduleIdentifier].fetchAcesChapInsuranceProviderSearch.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESProviderSearchSelectors
   */
  static isFetchingFetchAcesChapInsuranceProviderSearch = state =>
    state[selectors.moduleIdentifier].isFetchingFetchAcesChapInsuranceProviderSearch.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESProviderSearchSelectors
   */
  static fetchAcesChapInsuranceProviderSearchError = state =>
    state[selectors.moduleIdentifier].fetchAcesChapInsuranceProviderSearchError.payload;
}
